import { useState, useEffect, startTransition } from 'react';

const useScreenSize = () => {
    const isBrowser = typeof window !== 'undefined';
    const [screenSize, setScreenSize] = useState({
        width: 0,
        height: 0
    });

    useEffect(() => {
        if (!isBrowser) return undefined;

        startTransition(() => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        });

        const handleResize = () => {
            startTransition(() => {
                setScreenSize({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isBrowser]);

    return screenSize;
};

export default useScreenSize;
